import React, { useState, useRef, useEffect } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditCategoryForm = () => {
  const { id } = useParams(); 
  const [formData, setFormData] = useState({
    name: '',
    image: null,
    publish: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fileInputRef = useRef(null);

  
  useEffect(() => {
    const fetchCategoryData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/categories/getcategory/${id}` 
        );
        const category = response.data.category;
        setFormData({
          name: category.name,
          publish: category.publish,
          image: category.image || null, 
        });
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch category data');
        setLoading(false);
      }
    };
    
    fetchCategoryData();
  }, [id]); 

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const data = new FormData();
    data.append('name', formData.name);
    data.append('publish', formData.publish);
    if (formData.image) {
      data.append('image', formData.image);
    }
  
    try {
     
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/categories/edit/${id}`, 
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      console.log(response.data)
      toast.success(`${response.data.message}`);
      setFormData({
        name: '',
        image: null,
        publish: false,
      });
  
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
        console.log(error)
      toast.error('Category is not updated');
    }
  };
  

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <Box
      sx={{
        maxWidth: {
          xs: '100%',  
          md: '70%',  
        },
        margin: {xs:'0',md:'auto'},
        padding: {xs:0,md:2},
      }}
    >
      <form onSubmit={handleSubmit}>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Edit Category
          </legend>

          <Box sx={{ marginBottom: {xs: 1, md: 2}, maxWidth: {xs: "100%", sm: "100%", md: "100%"}, width: {xs: "100%"}}}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
              Name*
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              helperText="Insert Name"
              className="input-field-cls"
            />
          </Box>

          <Box sx={{ marginBottom: 2, maxWidth: {xs: "250px", md: "100%"}, width: {xs: "100%"}}}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
              Image*
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ marginBottom: '10px' }}
              ref={fileInputRef} 
            />
            
            {formData.image && !formData.image.name && (
  <Box sx={{ marginTop: '5px' }}>
    <img
      src={`${formData.image}`} 
      alt="Current Category"
      style={{
        width: '50px',
        height: '50px',
        objectFit: 'cover', 
        marginTop: '5px',
        borderRadius: '4px', 
      }}
    />
  </Box>
)}

            <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
              Insert image in jpg/png format
            </Typography>
          </Box>

          <Box sx={{ marginBottom: 2, maxWidth: {xs: "250px", md: "100%"}, width: {xs: "100%"}}}>
            <FormGroup sx={{ marginBottom: 1, fontWeight: '500' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.publish}
                    onChange={handleChange}
                    name="publish"
                  />
                }
                label="Publish"
              />
            </FormGroup>
          </Box>
        </fieldset>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant="contained" sx={{ bgcolor: 'green', color: '#fff' }} type="submit">
            <SaveIcon sx={{ pr: 1 }} />
            Save
          </Button>
          <Link to="/categories" style={{ textDecoration: 'none' }}>
            <Button variant="contained" sx={{ bgcolor: '#979797', color: '#fff' }}>
              <SettingsBackupRestoreIcon sx={{ pr: 1 }} />
              Back
            </Button>
          </Link>
        </Box>
      </form>
    </Box>
  );
};

export default EditCategoryForm;
